import type { Feature } from '@luna/gatekeeper';

export const automaticCardReplacement: Feature = {
    enabled: false,
    _description:
        'Displays automatic replacement card in the card services section in the bank card settings page and credit card functions page',
};
